// extracted by mini-css-extract-plugin
export default {"cart-tab":"CartTab_cart-tab__6gmup"};